<div class="sql-editor-container" [style.height.px]="contentHeight()">
  <!-- Main Horizontal Splitter: Database Schema (left) | Tabs + Content (right) -->
  <div id="target" class="control-section default-splitter">
    <div class="pane1">
      <ejs-splitter #horizontal height='100%' separatorSize=2 width='100%' orientation='Horizontal'>
        <e-panes>
          <!-- Left Pane: Database Schema -->
          <e-pane size='25%' min='200px'>
            <ng-template #content>
              <div class="content">
                <app-schema-explorer
                  class="schema-sidebar"
                  (generateQuery)="handleGenerateQuery($event)">
                </app-schema-explorer>
              </div>
            </ng-template>
          </e-pane>

          <!-- Right Pane: Tabs + Content -->
          <e-pane size='75%' min='200px'>
            <ng-template #content>
              <div class="content tabs-container">
                <!-- Tabs -->
                <div class="tabs">
                  <button class="tab-button" [class.active]="activeTab === 'sql'" (click)="onTabChange('sql')">
                    SQL Editor
                  </button>
                  <button class="tab-button" [class.active]="activeTab === 'visual'" (click)="onTabChange('visual')">
                    Visual Builder
                  </button>
                  <button class="tab-button" [class.active]="activeTab === 'json'" (click)="onTabChange('json')">
                    Query JSON
                  </button>
                </div>

                @if(activeTab === 'sql') {
                  <!-- SQL Editor Tab -->
                  <div class="tab-content sql-tab">
                    <ejs-splitter height='100%' separatorSize=2 width='100%' orientation='Vertical'>
                      <e-panes>
                        <e-pane size='30%' min='200px'>
                          <ng-template #content>
                            <div class="content pane-content">
                              <div class="toolbar">
                                <button class="toolbar-button execute-btn" (click)="executeQueryFromButton()" [disabled]="isExecuting">
                                  @if (isExecuting) {
                                  <div class="spinner-small"></div>
                                  } @else {
                                  <i class="fa fa-play"></i>
                                  }
                                  <span>Execute Query</span>
                                </button>

                                <button class="toolbar-button format-btn" (click)="formatQuery()">
                                  <i class="fa fa-align-left"></i>
                                  <span>Format</span>
                                </button>

                                <div class="toolbar-spacer"></div>

                                <div class="toolbar-spacer"></div>
                                <button class="toolbar-button clear-btn" (click)="clearEditor()">
                                  <i class="fa fa-times"></i>
                                  <span>Clear</span>
                                </button>

                                <div class="editor-info">
                                  {{ lineAndColumn() }}
                                </div>
                              </div>

                              <!-- Monaco Editor -->
                              <div class="editor-wrapper"
                                   (dragover)="onDragOver($event)"
                                   (dragleave)="onDragLeave($event)"
                                   (drop)="onDrop($event)">
                                <ngx-monaco-editor
                                  [(ngModel)]="sqlQuery"
                                  [options]="editorOptions"
                                  (onInit)="onEditorInit($event)"
                                  style="height: 500px; width: 100%;">
                                </ngx-monaco-editor>
                              </div>
                            </div>
                          </ng-template>
                        </e-pane>
                        <e-pane size='70%' min='200px'>
                          <ng-template #content>
                            <div class="content pane-content">
                              <!-- Query Results Panel -->
                              @if (showResults && queryResults && queryResults.success && queryResults.data) {
                              <div class="query-results-panel">
                                <!-- Results Header - Execution Time and Status -->
                                <div class="results-header">
                                  <div class="results-stats">
                                    <span class="stat-item">
                                      <i class="fa fa-clock-o"></i>
                                      {{ queryResults.metadata.executionTime }}ms
                                    </span>
                                    <span class="stat-item" [ngClass]="queryResults.success ? 'success-status' : 'error-status'">
                                      @if (queryResults.success) {
                                        <i class="fa fa-check"></i>
                                        Success
                                      } @else {
                                        <i class="fa fa-exclamation"></i>
                                        Failed
                                      }
                                    </span>
                                  </div>
                                </div>

                                <!-- Tab Custom Grid with Static Data Mode -->
                                <div class="results-grid-container">
                                  <app-tab-grid
                                    [value]="gridConfig"
                                    (gridFilterChange)="onGridFilterChange($event)"
                                    (gridSortChange)="onGridSortChange($event)"
                                    (gridGroupChange)="onGridGroupChange($event)"
                                  ></app-tab-grid>
                                </div>
                              </div>
                              } @else if (showResults && queryResults && !queryResults.success) {
                              <div class="query-results-panel">
                                <div class="query-results-error">
                                  <i class="fa fa-exclamation-circle"></i>
                                  <h3>SQL Syntax Error</h3>
                                  <pre class="error-message-text">{{ queryResults.error || 'Unknown error occurred' }}</pre>
                                </div>
                              </div>
                              } @else {
                              <!-- Empty State - No Query Executed Yet -->
                              <div class="results-empty-state">
                                <div class="empty-state-content">
                                  <i class="fa fa-database empty-state-icon"></i>
                                  <h3 class="empty-state-title">Ready to Query</h3>
                                  <p class="empty-state-description">
                                    Write your SQL query in the editor above and click <strong>Execute Query</strong> to see results here.
                                  </p>
                                  <div class="empty-state-tips">
                                    <div class="tip-item">
                                      <i class="fa fa-lightbulb-o"></i>
                                      <span>Press <kbd>F5</kbd> to execute your query</span>
                                    </div>
                                    <div class="tip-item">
                                      <i class="fa fa-table"></i>
                                      <span>Drag tables from the schema explorer on the left</span>
                                    </div>
                                    <div class="tip-item">
                                      <i class="fa fa-code"></i>
                                      <span>Use autocomplete (Ctrl+Space) for suggestions</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              }
                            </div>
                          </ng-template>
                        </e-pane>
                      </e-panes>
                    </ejs-splitter>
                  </div>
                }

                @else if (activeTab === 'visual') {
                  <!-- Visual Builder Tab -->
                  <div class="tab-content visual-tab">
                    <app-visual-query-builder
                      [sqlQuery]="sqlQuery"
                      [forceParse]="forceVisualParse"
                      [isTabActive]="activeTab === 'visual'"
                      [isExecuting]="isExecuting"
                      (sqlQueryChange)="onVisualBuilderSQLChange($event)"
                      (syncWarning)="onVisualBuilderWarning($event)"
                      (executeQuery)="executeQuery()"
                    ></app-visual-query-builder>
                  </div>
                }

                @else if(activeTab === 'json') {
                  <!-- Query JSON Tab -->
                  <div [style.display]="activeTab === 'json' ? 'flex' : 'none'" class="tab-content json-tab">
                    <div class="json-viewer">
                      <div class="json-input-section">
                        <label>Paste JSON Query Object:</label>
                        <textarea
                          class="json-input"
                          [(ngModel)]="jsonInput"
                          placeholder='Paste JSON here, e.g. { "QueryObjectID": "WorkItems", "ResultField_AppfieldIds": ["ID", "Title"], ... }'
                          rows="15">
                        </textarea>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </ng-template>
          </e-pane>
        </e-panes>
      </ejs-splitter>
    </div>
  </div>
</div>